export default (resolve, reject, fn) => async (error) => {
	if (error.code !== 'UserNotFoundException') {
		return reject(error)
	}

	return fn()
}
